import { render, staticRenderFns } from "./layout-product-gallery.vue?vue&type=template&id=c484d19e&scoped=true&"
import script from "./layout-product-gallery.vue?vue&type=script&lang=js&"
export * from "./layout-product-gallery.vue?vue&type=script&lang=js&"
import style0 from "./layout-product-gallery.vue?vue&type=style&index=0&id=c484d19e&lang=scss&scoped=true&"
import style1 from "./layout-product-gallery.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c484d19e",
  null
  
)

export default component.exports